
import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Users } from "lucide-react";

interface CapacitySelectProps {
  value: string;
  onChange: (value: string) => void;
}

const CapacitySelect = ({ value, onChange }: CapacitySelectProps) => {
  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-medium">Team Capacity</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full bg-white">
          <Users className="w-4 h-4 mr-2 text-[#FF4A8E]" />
          <SelectValue placeholder="Select capacity" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {Array.from({ length: 12 }, (_, i) => (
              <SelectItem key={i + 1} value={String(i + 1)}>
                {i + 1} {i === 0 ? 'Opportunity' : 'Opportunities'}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default CapacitySelect;
